import React from "react";
import { useState, useEffect } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Tabs from "@mui/material/Tabs";
import { Menu, MenuItem } from "@mui/material";
import Tab from "@mui/material/Tab";
import { grey } from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getDataIx0, putData } from "../../../../services/library";
import DireccionesEntrega from "./direccionescliente/DireccionesEntrega";
import TablaTanques from "./tanquescliente/TablaTanques";
import ListContratos from "./contratos/ListContratos";
import PedidosCli from "./PedidosCli";
import DatosCli from "./DatosCli";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ReclamosCli from "./reclamos/ReclamosCli";
import ImpuestosCliente from "./impuestos/ImpuestosCliente";
import Comprobantes from "./cuentacorriente/Comprobantes";
import LoopIcon from "@mui/icons-material/Loop";
import DialogNuevoCliente from "./cambio_titularidad/DialogoNuevoCliente";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { UrlApi } from "../../../../services/apirest";
import PersonIcon from "@mui/icons-material/Person";
import HistoryIcon from "@mui/icons-material/History";
import { getData } from "../../../../services/library";
import DocumentacionCli from "./DocumentacionCli";
import Navbar from "../../../Navbar";

//aa

function FichaCliente(props) {
  const ITEM_HEIGHT = 48;

  const navigate = useNavigate();
  const { id, tab } = useParams(); //Si tengo parametro , lo guardo en id de cliente

  const id_cliente = id || props.datos.id; // en id_cliente, si tengo parametros, uso esos, y si no, uso props.datos.id
  // console.log("PROPS", props);

  const [datosCliente, setDatosCliente] = useState(null); //aca voy a guardar todos los datos del cliente. NO LO GUARDO DE PROPS.DATOS, PORQUE COMO ES POSIBLE QUE SE REALICEN MODIFICACIONES DE LOS DATOS DEL CLIENTE, QUIERO VOLVER A OBTENERLOS Y VOLVER A SETEARLOS CUANDO SEA NECESARIO.
  const [parametros, setParametros] = useState();

  //Estados para mostrar componentes:
  const [showFormCambioTitularidad, setShowFormCambioTitularidad] =
    useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  /************************************************************************************************/
  //Maneja TAB
  const [opcion, setOpcion] = useState(tab || "datos");

  const handleChange = (event, newValue) => {
    setOpcion(newValue);
  };

  //Cierra la ficha del cliente
  const handleClose = () => {
    if (props.ficha && props.tabla && props.setDatos) {
      props.setDatos({});
      props.ficha(false);
      props.tabla(true);
    }
    navigate("/clientes");
  };

  useEffect(() => {
    obtenerDataCliente();
    getData("/cambio_titularidad_parametros", setParametros);
  }, [id_cliente]);

  const [soloLectura, setSoloLectura] = useState(null);
  const [tabColor, setTabColor] = useState();

  const obtenerDataCliente = async () => {
    setDatosCliente(null);
    await getDataIx0("/clientes/" + id_cliente, setDatosCliente);
  };

  useEffect(() => {
    if (!!datosCliente) {
      setSoloLectura(datosCliente?.activo === 0);
      setTabColor(datosCliente?.activo === 0 ? "#566573" : "#007BCE");
    }
  }, [datosCliente]);

  // ******************************** saldos de cliente ************************************************ //

  const handleCambioTitularidad = async () => {
    const consultaSaldo = parseInt(
      parametros.filter((p) => p.parametro === "consulta_saldo_sisven")[0]
        .valor,
    );
    if (consultaSaldo === 1) {
      if (!datosCliente.id_empresa) {
        alert("El cliente no tiene empresa registrada.");
        return;
      }
      try {
        const { id_empresa, sisven_id } = datosCliente;
        const endpoint = `${UrlApi}/apicobol/saldos/${id_empresa}/${sisven_id}`;

        const response = await fetch(`${endpoint}`, {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
        });
        const resultado = await response.json();
        if (resultado > 0)
          alert(
            `El cliente ${datosCliente.razon_social.trim()} (${
              datosCliente.sisven_id
            }) tiene un SALDO de ${resultado.toLocaleString("es-AR", {
              style: "currency",
              currency: "ARS",
            })}. Por favor revisar cuenta corriente.`,
          );
      } catch (error) {
        alert("Error al obtener saldo del cliente.");
      }
    }
    setShowFormCambioTitularidad(true);
    handleCloseMenu();
  };

  const habilitar = () => {
    const parametro = parametros.filter(
      (p) => p.parametro === "sectores_habilitados",
    )[0].valor;
    const sectoresHabilitados = parametro
      .split(",")
      .map((n) => parseInt(n, 10));
    const sectorUsuario = parseInt(localStorage.getItem("sector"));
    const habilitado = sectoresHabilitados.includes(sectorUsuario);
    return habilitado;
  };

  //consulta para ver si lo habilita
  const habilitaCambioTitularidad = parametros && habilitar();

  return (
    <div>
      {/* <Navbar/> */}
      <Container maxWidth="xl">
        <Grid
          container
          my={1}
          backgroundColor={soloLectura ? "#566573" : "#1F618D"}
          justifyContent="center"
          alignItems="center"
          borderRadius={5}
        >
          <Grid item xs={1}>
            <IconButton onClick={handleClose}>
              <ArrowBackIcon sx={{ color: grey[50] }} />
            </IconButton>
          </Grid>

          <Grid container justifyContent="center" alignItems="center" xs={10}>
            <PersonIcon sx={{ color: "#fff", fontSize: 25 }} />
            <Typography variant="body2" color="white" sx={{ fontSize: 20 }}>
              {`${datosCliente?.razon_social || "Cargando datos.."} (${
                datosCliente?.sisven_id || "Sisven ID no registrado"
              })`}
            </Typography>
          </Grid>

          {!soloLectura ? (
            <>
              <Grid item container justifyContent="flex-end" xs={1}>
                <IconButton
                  aria-label="more"
                  id="long-button"
                  aria-controls={open ? "long-menu" : undefined}
                  aria-expanded={open ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreVertIcon sx={{ color: "#fff" }} />
                </IconButton>
                <Menu
                  id="long-menu"
                  MenuListProps={{
                    "aria-labelledby": "long-button",
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleCloseMenu}
                  slotProps={{
                    paper: {
                      style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: "25ch",
                      },
                    },
                  }}
                >
                  <MenuItem
                    disabled={soloLectura || !habilitaCambioTitularidad}
                    onClick={async () => {
                      handleCambioTitularidad();
                    }}
                  >
                    <LoopIcon
                      sx={{ fontSize: 18, marginRight: 1 }}
                      color="success"
                    />
                    Cambiar titularidad
                  </MenuItem>

                  <MenuItem
                    disabled={!datosCliente?.id_titular_anterior}
                    onClick={() => {
                      window.open(
                        `/#/clientes/profile/${datosCliente.id_titular_anterior}/datos`,
                        "_blank",
                      );

                      handleCloseMenu();
                    }}
                  >
                    <HistoryIcon
                      sx={{ fontSize: 18, marginRight: 1 }}
                      color="primary"
                    />
                    Ver Titular Anterior
                  </MenuItem>
                </Menu>
              </Grid>
            </>
          ) : (
            <>
              <Grid item xs={1}></Grid>
            </>
          )}
        </Grid>

        {datosCliente ? (
          <>
            <>
              <Box sx={{ width: "100%" }}>
                <Tabs
                  variant="fullWidth"
                  value={opcion}
                  onChange={handleChange}
                  indicatorColor={"primary"} // lo sobrescribimos con sx
                  aria-label="Clientes"
                  sx={{
                    "& .MuiTab-root": {
                      color: soloLectura ? "#566573" : "primary", // texto de los tabs
                    },
                    "& .Mui-selected": {
                      color: soloLectura ? "#566573" : "primary", // texto del tab seleccionado
                    },
                    "& .MuiTabs-indicator": {
                      backgroundColor: soloLectura ? "#566573" : "primary", // color del indicador
                    },
                  }}
                >
                  <Tab value="datos" label="Datos" />
                  {datosCliente.inscripcion_iibb==1 && (    
                    <Tab value="impuestos" label="Impuestos" />
                  )}
                  <Tab value="direcciones" label="Direcciones de Entrega" />
                  <Tab value="tanques" label="Tanques" />
                  <Tab value="pedidos" label="Pedidos" />
                  <Tab value="reclamos" label="Reclamos" />
                  <Tab value="cc" label="cuenta corriente" />
                  <Tab value="doc" label="documentación" />
                </Tabs>
                <br />
              </Box>
              {opcion === "datos" ? (
                <DatosCli
                  datos={datosCliente}
                  ficha={props.ficha}
                  tabla={props.tabla}
                  actualizar={props.actualizar}
                  obtenerDatos={obtenerDataCliente}
                  soloLectura={soloLectura}
                  edicionIlimitada={props.edicionIlimitada}
                />
              ) : null}
              {opcion === "impuestos" ? (
                <ImpuestosCliente
                  cliente={datosCliente}
                  soloLectura={soloLectura}
                />
              ) : null}
              {opcion === "direcciones" ? (
                <DireccionesEntrega
                  cliente={datosCliente}
                  soloLectura={soloLectura}
                />
              ) : null}
              {opcion === "tanques" ? (
                <TablaTanques datos={datosCliente} soloLectura={soloLectura} />
              ) : null}
              {opcion === "contratos" ? (
                <ListContratos datos={datosCliente} soloLectura={soloLectura} />
              ) : null}
              {opcion === "pedidos" ? (
                <PedidosCli
                  datos={datosCliente}
                  opcion={"pedidos"}
                  tabs={props.setShowTabs}
                  soloLectura={soloLectura}
                  permisos={props.permisos}
                />
              ) : null}
              {opcion === "reclamos" ? (
                <ReclamosCli cliente={datosCliente} soloLectura={soloLectura} />
              ) : null}
              {opcion === "cc" ? (
                <Comprobantes
                  cliente={datosCliente}
                  soloLectura={soloLectura}
                />
              ) : null}
              {opcion === "doc" ? (
                <DocumentacionCli
                  cliente={datosCliente}
                  soloLectura={soloLectura}
                ></DocumentacionCli>
              ) : null}
            </>
          </>
        ) : (
          <>
            <Grid
              container
              direction="column"
              justifyContent="center"
              alignItems="center"
              p={3}
            >
              <Grid item xs>
                <Typography m={6} fontSize={30} variant="h2" color="initial">
                  Cargando información de cliente...
                </Typography>
              </Grid>
              <Grid item>
                <CircularProgress size="7rem" color="primary" />
              </Grid>
            </Grid>
          </>
        )}
      </Container>
      {showFormCambioTitularidad && (
        <DialogNuevoCliente
          open={showFormCambioTitularidad}
          setOpen={setShowFormCambioTitularidad}
          cliOriginal={datosCliente}
        />
      )}
    </div>
  );
}

export default FichaCliente;
